var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisionIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3406 1.97309C21.7706 1.49728 21.1018 1.15438 20.3828 0.969301C19.6637 0.784221 18.9125 0.761603 18.1836 0.903092L16.4196 1.33609C15.4992 1.50475 14.6671 1.99075 14.068 2.70953C13.4689 3.42831 13.1407 4.33437 13.1406 5.27009V20.7371C12.4775 20.8341 11.8038 20.8341 11.1406 20.7371V5.27009C11.1439 4.34283 10.8235 3.4435 10.2345 2.7273C9.64556 2.01109 8.82506 1.52294 7.91463 1.34709L6.04063 0.892092C5.31978 0.760186 4.57876 0.788342 3.87 0.974568C3.16125 1.16079 2.50209 1.50054 1.93919 1.96975C1.37629 2.43896 0.923411 3.02616 0.612607 3.6898C0.301803 4.35344 0.140674 5.07728 0.140625 5.81009L0.140625 16.6031C0.140682 17.7739 0.551602 18.9075 1.30176 19.8065C2.05192 20.7054 3.09373 21.3125 4.24563 21.5221L10.5316 22.6651C11.5956 22.8584 12.6857 22.8584 13.7496 22.6651L20.0406 21.5221C21.1918 21.3114 22.2326 20.7037 22.9817 19.8047C23.7309 18.9057 24.141 17.7723 24.1406 16.6021V5.81009C24.1411 5.07754 23.98 4.35389 23.6689 3.69068C23.3578 3.02748 22.9043 2.44103 22.3406 1.97309Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon2);
export default __webpack_public_path__ + "static/media/vision-icon-2.8246ed517c779a014a083f11a9cdd09c.svg";
export { ForwardRef as ReactComponent };